import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { AlertCircle, CheckCircle2 } from "lucide-react";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const Icon = props.variant === "destructive" ? AlertCircle : CheckCircle2;
        const iconClassName = props.variant === "destructive" ? "text-destructive" : "text-primary";

        return (
          <Toast key={id} {...props}>
            <div className="flex items-start gap-3">
              <span className="mt-0.5 rounded-full bg-muted p-1">
                <Icon className={`h-4 w-4 ${iconClassName}`} />
              </span>
              <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
